(() => {
  const searchPageSelector = '.template-search';
  const sortSelectSelector = `${searchPageSelector} select[name="sort_by"]`;
  const collator = new Intl.Collator('es', { sensitivity: 'base', numeric: true });

  function requestedSort() {
    return new URLSearchParams(window.location.search).get('sort_by') || 'relevance';
  }

  function syncSortSelects(sortBy) {
    document.querySelectorAll(sortSelectSelector).forEach((select) => {
      if (Array.from(select.options).some((option) => option.value === sortBy)) {
        select.value = sortBy;
      }
    });
  }

  function numericValue(item, name) {
    const value = Number(item.dataset[name]);
    return Number.isFinite(value) ? value : 0;
  }

  function compareProducts(first, second, sortBy) {
    const firstAvailable = first.dataset.searchSortAvailable === 'true';
    const secondAvailable = second.dataset.searchSortAvailable === 'true';

    if (firstAvailable !== secondAvailable) return firstAvailable ? -1 : 1;

    let comparison = 0;
    if (sortBy === 'title-ascending' || sortBy === 'title-descending') {
      comparison = collator.compare(first.dataset.searchSortTitle || '', second.dataset.searchSortTitle || '');
      if (sortBy === 'title-descending') comparison *= -1;
    } else if (sortBy === 'price-ascending' || sortBy === 'price-descending') {
      comparison = numericValue(first, 'searchSortPrice') - numericValue(second, 'searchSortPrice');
      if (sortBy === 'price-descending') comparison *= -1;
    } else if (sortBy === 'created-ascending' || sortBy === 'created-descending') {
      comparison = numericValue(first, 'searchSortDate') - numericValue(second, 'searchSortDate');
      if (sortBy === 'created-descending') comparison *= -1;
    }

    if (comparison !== 0) return comparison;
    return numericValue(first, 'searchSortOriginal') - numericValue(second, 'searchSortOriginal');
  }

  function applySearchSort(sortBy = requestedSort()) {
    const searchPage = document.querySelector(searchPageSelector);
    if (!searchPage) return;

    syncSortSelects(sortBy);

    const productList = searchPage.querySelector('#ProductGridContainer [data-search-product-list]');
    if (!productList) return;

    const products = Array.from(productList.querySelectorAll(':scope > [data-search-sort-item]'));
    const sortedProducts = [...products].sort((first, second) => compareProducts(first, second, sortBy));

    if (sortedProducts.some((product, index) => product !== products[index])) {
      productList.append(...sortedProducts);
    }
  }

  document.addEventListener('input', (event) => {
    if (!event.target.matches(sortSelectSelector)) return;
    applySearchSort(event.target.value);
  }, true);

  document.addEventListener('bit:search-results-updated', () => applySearchSort());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applySearchSort(), { once: true });
  } else {
    applySearchSort();
  }
})();
